import React, { useEffect, useState, useMemo } from "react";
import { FaSquare, FaCheckSquare, FaMinusSquare } from "react-icons/fa";
import { IoMdArrowDropright } from "react-icons/io";
import TreeView, { flattenTree } from "react-accessible-treeview";
import cx from "classnames";
import "./RolePermissionTree.scss";

const initValue = {
  name: "",
  children: [
    {
      name: "Dashboard",
      children: [],
    },
  ],
};


const ArrowIcon = ({ isOpen, className }:any) => {
  const baseClass = "arrow";
  const classes = cx(
    baseClass,
    { [`${baseClass}--closed`]: !isOpen },
    { [`${baseClass}--open`]: isOpen },
    className
  );
  const Arrow: any = IoMdArrowDropright;
  return <Arrow className={classes} />;
};

const CheckBoxIcon = ({ variant, ...rest }:any) => {
  const FaCheckSquareIcon:any = FaCheckSquare;
  const FaSquareIcon: any = FaSquare;
  const FaMinusSquareIcon: any = FaMinusSquare;
  
  switch (variant) {
    case "all":
      return <FaCheckSquareIcon {...rest} />;
    case "none":
      return <FaSquareIcon {...rest} />;
    case "some":
      return <FaMinusSquareIcon {...rest} />;
    default:
      return null;
  }
};



const RolePermissionMenuTree =({menuList, setMenuPermissionList}:any)=> {
    const [finalMenuList, setFinalMenuList] = useState<any>(initValue);
    const [selectedIds, setSelectedIds] = useState<any>();

    const handleOnSelect = (props:any) => {
      const selectedIdsArray = Array.from(props.treeState.selectedIds);
       setMenuPermissionList(selectedIdsArray);
    }

    const transformedData = useMemo(() => {
      const transformMenuItem = (item: any) => {
        const { name, id, route, isChecked, childMenus } = item;
        const result: any = {
          name,
          id,
          metadata: { route, isChecked },
          children: [],
        };
        if (childMenus && childMenus.length > 0) {
          result.children = childMenus.map(transformMenuItem);
        }
        return result;
      };

      if (!menuList?.Menu) {
        return initValue;
      }

      const menuData = menuList.Menu.reduce(
        (acc: any, menuItem: any) => {
          acc.children.push(transformMenuItem(menuItem));
          return acc;
        },
        { name: "", children: [] }
      );

      return menuData;
    }, [menuList]);

    const preSelectedIds = useMemo(() => {
      const getCheckedIds = (permission: any): number[] => {
        let ids: number[] = [];
        if (permission.isChecked) {
          ids.push(permission.id);
        }
        if (permission.childMenus && permission.childMenus.length > 0) {
          ids = ids.concat(
            ...permission.childMenus.map((child: any) => getCheckedIds(child))
          );
        }
        return ids;
      };

      if (!menuList) {
        return [];
      }

      return Object.keys(menuList).flatMap((module) =>
        menuList[module].flatMap((permission: any) => getCheckedIds(permission))
      );
    }, [menuList]);

    useEffect(()=>{
        if(transformedData){
            setFinalMenuList(transformedData);
        }
        if (preSelectedIds) {
            setSelectedIds(preSelectedIds);
        }
    },[transformedData, preSelectedIds]);

  return (
    <div>
      <div className="checkbox">
        <TreeView
          data={flattenTree(finalMenuList)}
          aria-label="Checkbox tree"
          multiSelect
          propagateSelect={false}
          propagateSelectUpwards
          togglableSelect
          selectedIds={selectedIds}
          onSelect={(props:any) => {
            handleOnSelect(props);
          }}
          nodeRenderer={({
            element,
            isBranch,
            isExpanded,
            isSelected,
            isHalfSelected,
            getNodeProps,
            level,
            handleSelect,
            handleExpand,
          }) => {
            return (
              <div
                {...getNodeProps({ onClick: handleExpand })}
                style={{ marginLeft: 40 * (level - 1) }}
              >
                {isBranch && <ArrowIcon isOpen={isExpanded} />}
                 <CheckBoxIcon
                    className="checkbox-icon"
                    onClick={(e:any) => {
                        handleSelect(e);
                        e.stopPropagation();
                    }}
                    variant={
                        isHalfSelected ? "some" : isSelected ? "all" : "none"
                    }
                    />
                <span className="name">{element.name}</span>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
}



export default RolePermissionMenuTree;